import { Component, OnInit } from '@angular/core';
import { Helper } from './../Helper';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {

	TERM_AND_CONDITIONS_FOR_TRAINER = '';
  constructor(
   public Helper:Helper,
   public dialogRef: MatDialogRef<TermsConditionComponent>
  ) {
  	this.Helper.makeRequest("get-cms-page-content/TERM_AND_CONDITIONS_FOR_TRAINER",{},"get",{toast:false})
    .subscribe(data=>{
      this.TERM_AND_CONDITIONS_FOR_TRAINER=data.data;
    })

   }
 close(){
  this.dialogRef.close()
 }
  ngOnInit() {
  }

}
